'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var PeerId = require('peer-id');

var CID = require('cids');

var _require = require('../../utils'),
    withTimeoutOption = _require.withTimeoutOption;

module.exports = function (_ref) {
  var bitswap = _ref.bitswap;
  return withTimeoutOption( /*#__PURE__*/function () {
    var _wantlist = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(peerId) {
      var options,
          list,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};

              // eslint-disable-line require-await
              if (peerId && !CID.isCID(peerId) && typeof peerId !== 'string' && !Buffer.isBuffer(peerId) && !PeerId.isPeerId(peerId)) {
                options = peerId;
                peerId = null;
              }

              list = peerId ? bitswap.wantlistForPeer(PeerId.createFromCID(peerId)) : bitswap.getWantlist(options);
              return _context.abrupt("return", Array.from(list).map(function (e) {
                return e[1].cid;
              }));

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function wantlist(_x) {
      return _wantlist.apply(this, arguments);
    }

    return wantlist;
  }());
};